/** Internal messaging copy in Arabic. Mirrors `../../en/home/messaging.js` key for key. */
import messagesMini from '@/assets/images/screens/messages-mini.webp'

import { ACTIONS } from '../site'

export const MESSAGING = {
  eyebrow: 'المراسلة الداخلية',
  title: 'تحدّث مع فريقك',
  mark: 'دون مغادرة التطبيق',
  text: 'رسائل مباشرة ومحادثات جماعية ومحادثة لكل اجتماع. اعرف من قرأ الرسالة، وردّ عليها، وشارك الملفات، مع ظهور دور كل شخص بجانب اسمه.',
  cta: ACTIONS.demo,
  art: {
    screen: messagesMini,
    photo: { title: 'تجهيز قاعة النيل', meta: 'شاركتها نورة · الموارد البشرية' },
    seen: {
      avatars: [
        { initials: 'OF', tone: 'teal' },
        { initials: 'NA', tone: 'violet' },
        { initials: 'SH', tone: 'orange' },
      ],
      label: 'شاهدها 4',
    },
  },
}
